import React, { Component } from "react";

import queryString from "query-string";

import { Card, CardBody, Col, Container, Nav, NavItem, Row, TabContent, TabPane } from "reactstrap";

// datatable related plugins
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";

import { connect } from "react-redux";
import PropTypes from "prop-types";
import styled from "styled-components";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
//import DynamicFormFilterBetween from "../../../components/forms/DynamicFormFilterBetween";

import {
  getTransactionReconciliation,
  setDateTransitions,
} from "../../../store/transactions/actions";
import {
  getUsersToList,
} from "../../../store/user/user-list/actions";
import {
  setUsersActionsFilters
} from "../../../store/user-actions/actions";
import { getLegalEntityList } from "../../../store/legal-entity/actions";
import { getContractorsList } from "../../../store/contractors/actions";
import { monthNames } from "../../../helpers/utils";
import ReactTableForm from "../../../components/Common/ReactTableForm";
import DynamicFormFilters from "../../../components/forms/DynamicFormFilters";

import {
  getServiceProvidersList,
} from "../../../store/service-provider/actions";

import ModifiedMetaTags from '../../../components/ModifiedMetaTags/index';
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import classnames from 'classnames';
import UsersRec from "./users";
import ClientsAndProvidersRec from "./clients-and-providers";
import UsersRecUAH from "./users-uah";
import ClientsAndProvidersRecUAH from "./clients-and-providers-uah";

class Reconciliation extends Component {
  constructor(props) {
    super(props);
    let date = new Date();

    this.state = {
      activeTab: "clients",
      date: {
        start_date: new Date(date.getFullYear(), date.getMonth(), 1 + 1)
          .toJSON()
          .split("T")[0],
        end_date: new Date(date.getFullYear(), date.getMonth() + 1, 0 + 1)
          .toJSON()
          .split("T")[0],
      },
      activeFilters: {},
      activeFiltersForUser: {},
    };
  }

  componentDidMount() {
    const location = this.props.history.location;
    const hash = location.hash.split("#").join("") || "clients";

    this.toggle(hash);

    this.props.getServiceProvidersList({
      sizePerPage: 0,
      page: 1
    })

    this.props.getUsersToList({
      sizePerPage: 0,
      page: 1
    });

    this.props.getContractorsList({
      sizePerPage: 0,
    });
    this.props.getLegalEntityList({
      sizePerPage: 0,
    });


    let parsedSearch = queryString.parse(this.props.history.location.search);
    let formattedSearch = {};

    for (const [key, value] of Object.entries(parsedSearch)) {
      if (value !== null) {
        formattedSearch[key] = value;
      }
    }

    if (formattedSearch?.start_date) {
      let dt = {
        start_date: formattedSearch?.start_date,
        end_date: formattedSearch?.end_date,
      };
      this.props.history.push({
        search: queryString.stringify(formattedSearch),
      });
      this.props.setDateTransitions(dt);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location.hash !== this.props.location.hash) {
      // this.handleUpdateTab();
    }

    if (prevProps.contractors !== this.props.contractors) {
      let params = {
        ...this.props.defDate,
      };
      this.props.history.push({
        search: queryString.stringify({
          start_date: this.props.defDate.start_date,
          end_date: this.props.defDate.end_date,
        }),
      });
      // this.props.getTransactionReconciliation(params);
    }
  }

  componentWillUnmount() {
    this.props.getTransactionReconciliation({
      ...this.state.activeFiltersForUser,
      start_date: this.props.defDate.start_date,
      end_date: this.props.defDate.end_date,
      clients_report: true,
      beneficiary_company_currency: this.checkCurrency('clients')
    });
  }

  handleUpdateTab = () => {
    const hash = this.props.location.hash.split("#").join("") || "clients";
    this.toggle(hash)
  };

  checkCurrency = (tab) => {
    if (tab == 'clients' || tab == 'users-and-service-providers') {
      return 'USD'
    } else {
      return 'UAH'
    }
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });

      if (tab !== 'clients' && tab !== 'clients-uah') {
        this.props.getTransactionReconciliation({
          ...this.state.activeFiltersForUser,
          start_date: this.props.defDate.start_date,
          end_date: this.props.defDate.end_date,
          clients_report: false,
          beneficiary_company_currency: this.checkCurrency(tab)
        });
      } else {
        this.props.getTransactionReconciliation({
          ...this.state.activeFiltersForUser,
          start_date: this.props.defDate.start_date,
          end_date: this.props.defDate.end_date,
          clients_report: true,
          beneficiary_company_currency: this.checkCurrency(tab)
        });
      }
    }
  }

  handleTableChange = data => { };

  onFiltersChange = (filters, type, status) => {
    const { start_date, end_date } = this.props.defDate;
    const hash = location.hash.split("#").join("") || "clients";

    if (Object.keys(filters).length > 1) {
      let days = {
        start_date: filters.start_date || start_date,
        end_date: filters.end_date || end_date,
      };
      this.setState({
        activeFilters: {
          ...filters,
          ...days,
        },
      });


      this.props.getTransactionReconciliation({
        ...filters,
        ...days,
        beneficiary_company_currency: this.checkCurrency(hash),
        clients_report: true
      });
    }

  };

  onFiltersChangeForUser = (filters, type, status) => {
    const { start_date, end_date } = this.props.defDate;
    const hash = location.hash.split("#").join("") || "clients";

    if (Object.keys(filters).length > 1) {

      let days = {
        start_date: filters.start_date || start_date,
        end_date: filters.end_date || end_date,
      };

      this.setState({
        activeFiltersForUser: {
          ...filters,
          ...days,
        },
      });

      this.props.getTransactionReconciliation({
        ...filters,
        ...days,
        beneficiary_company_currency: this.checkCurrency(hash),
        clients_report: false
      });
    }
  };

  handleDateRangeChange = filterDate => {
    const location = this.props.history.location;
    const hash = location.hash.split("#").join("") || "clients";

    let prevHistory = queryString.parse(this.props.history.location.search);

    let days = {
      start_date: filterDate.start_date,
      end_date: filterDate.end_date,
    };

    let dt = {
      ...prevHistory,
      ...this.state.activeFilters,
      start_date: filterDate.start_date,
      end_date: filterDate.end_date,
    };

    if (dt?.start_date && dt?.end_date) {
      let formQueryString = queryString.stringify(
        Object.assign(prevHistory, {
          ...days,
        })
      );

      this.props.history.push({ search: formQueryString, hash: hash });
      return this.props.setDateTransitions(dt);
    }
  };

  render() {

    const onClickRow = (e, row) => {
      // this.props.history.push(`/invoices/${row.id}`);
    };

    return (
      <MainStyle>
        <div className="page-content">
          <ModifiedMetaTags title="Reconciliations | Mobihunter" />
          <Container fluid>
            <Breadcrumbs
              title="Dashboard"
              breadcrumbItem="Reconciliations"
              link="/dashboard"
            />

            <Row>
              <Col sm="col-12">
                <Card className="mb-0">
                  <CardBody>
                    <Nav
                      tabs
                      className="nav-tabs-custom"
                      style={{
                        width: "80%",
                        borderBottom: "0",
                      }}
                    >
                      <NavItem>
                        <Link
                          style={{ cursor: "pointer" }}
                          to={{
                            hash: "clients",
                            search: this.props.location.search,
                          }}
                          className={classnames("nav-link", {
                            active: this.state.activeTab === "clients",
                          })}
                          onClick={() => {
                            this.toggle("clients");
                          }}
                        >
                          Clients (USD)
                        </Link>
                      </NavItem>
                      <NavItem>
                        <Link
                          style={{ cursor: "pointer" }}
                          to={{
                            hash: "users-and-service-providers",
                            search: this.props.location.search,
                          }}
                          className={classnames("nav-link", {
                            active: this.state.activeTab === "users-and-service-providers",
                          })}
                          onClick={() => {
                            this.toggle("users-and-service-providers");
                          }}
                        >
                          Users & Service providers (USD)
                        </Link>
                      </NavItem>
                      <NavItem>
                        <Link
                          style={{ cursor: "pointer" }}
                          to={{
                            hash: "clients-uah",
                            search: this.props.location.search,
                          }}
                          className={classnames("nav-link", {
                            active: this.state.activeTab === "clients-uah",
                          })}
                          onClick={() => {
                            this.toggle("clients-uah");
                          }}
                        >
                          Clients (UAH)
                        </Link>
                      </NavItem>
                      <NavItem>
                        <Link
                          style={{ cursor: "pointer" }}
                          to={{
                            hash: "users-and-service-providers-uah",
                            search: this.props.location.search,
                          }}
                          className={classnames("nav-link", {
                            active: this.state.activeTab === "users-and-service-providers-uah",
                          })}
                          onClick={() => {
                            this.toggle("users-and-service-providers-uah");
                          }}
                        >
                          Users & Service providers (UAH)
                        </Link>
                      </NavItem>
                    </Nav>
                  </CardBody>
                </Card>
              </Col>
            </Row>

          </Container>

          <TabContent
            activeTab={this.state.activeTab}
            className="text-muted"
            style={{ padding: "40px 12px 0px 12px" }}
          >
            <TabPane tabId="clients">
              <Row>
                <Col className="col-12">
                  {this.state.activeTab === 'clients' && (
                    <UsersRec
                      history={this.props.history}
                      permissions={this.props.permissions}
                      reconciliations={this.props.reconciliations}
                      loader_reconciliation={this.props.loader_reconciliation}
                      defDate={this.props.defDate}
                      onFiltersChange={this.onFiltersChange}
                      handleDateRangeChange={this.handleDateRangeChange}
                      contractors={this.props.contractors}
                      legalEntity={this.props.legalEntity}
                    />
                  )}
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId="users-and-service-providers">
              <Row>
                <Col className="col-12">
                  {this.state.activeTab === 'users-and-service-providers' && (
                    <ClientsAndProvidersRec
                      history={this.props.history}
                      permissions={this.props.permissions}
                      reconciliations={this.props.reconciliations}
                      loader_reconciliation={this.props.loader_reconciliation}
                      defDate={this.props.defDate}
                      onFiltersChange={this.onFiltersChangeForUser}
                      handleDateRangeChange={this.handleDateRangeChange}
                      users={this.props.users}
                      service_providers={this.props.service_providers}
                    />
                  )}
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId="clients-uah">
              <Row>
                <Col className="col-12">
                  {this.state.activeTab === 'clients-uah' && (
                    <UsersRecUAH
                      history={this.props.history}
                      permissions={this.props.permissions}
                      reconciliations={this.props.reconciliations}
                      loader_reconciliation={this.props.loader_reconciliation}
                      defDate={this.props.defDate}
                      onFiltersChange={this.onFiltersChange}
                      handleDateRangeChange={this.handleDateRangeChange}
                      contractors={this.props.contractors}
                      legalEntity={this.props.legalEntity}
                    />
                  )}
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId="users-and-service-providers-uah">
              <Row>
                <Col className="col-12">
                  {this.state.activeTab === 'users-and-service-providers-uah' && (
                    <ClientsAndProvidersRecUAH
                      history={this.props.history}
                      permissions={this.props.permissions}
                      reconciliations={this.props.reconciliations}
                      loader_reconciliation={this.props.loader_reconciliation}
                      defDate={this.props.defDate}
                      onFiltersChange={this.onFiltersChangeForUser}
                      handleDateRangeChange={this.handleDateRangeChange}
                      users={this.props.users}
                      service_providers={this.props.service_providers}
                    />
                  )}
                </Col>
              </Row>
            </TabPane>
          </TabContent>

        </div>
      </MainStyle>
    );
  }
}

const MainStyle = styled.div`
  .rec--filters {
  }
`;

const ScrollTable = styled.div`
  overflow-x: auto;

  .rec--table {
    min-width: 1200px;
  }
`;

const StyleFooter = styled.div`
  font-size: 14px;

  div {
    span {
      font-weight: 600;
    }
  }
`;
const NameLink = styled.div`
  transition-duration: 0.1s;

  &:hover {
    /* color: rgb(85, 110, 230); */
    transition-duration: 0.1s;
  }
`;

Reconciliation.propTypes = {
  history: PropTypes.object.isRequired,
  contractors: PropTypes.object,
  legalEntity: PropTypes.object,
  permissions: PropTypes.object.isRequired,
  defDate: PropTypes.object.isRequired,
  reconciliations: PropTypes.object.isRequired,
  loader_reconciliation: PropTypes.bool,
  getTransactionReconciliation: PropTypes.func.isRequired,
  setDateTransitions: PropTypes.func.isRequired,
  getContractorsList: PropTypes.func.isRequired,
  getLegalEntityList: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  users: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  getUsersToList: PropTypes.func.isRequired,
  setUsersActionsFilters: PropTypes.func.isRequired,
  getServiceProvidersList: PropTypes.func.isRequired,
  service_providers: PropTypes.arrayOf({}),
};

const mapStateToProps = state => ({
  permissions: state.User.permissions,
  defDate: state.transactions.defDate,
  contractors: state.ContractorList.data,
  legalEntity: state.LegalEntityList.data,
  reconciliations: state.transactions.reconciliation,
  loader_reconciliation: state.transactions.reconciliation_loaders, // reconciliation_loader
  users: state.UsersList.data,
  service_providers: state.ServiceProviders.data,
});

export default connect(mapStateToProps, {
  setDateTransitions,
  getTransactionReconciliation,
  getContractorsList,
  getLegalEntityList,
  getUsersToList,
  getServiceProvidersList,
  setUsersActionsFilters
})(Reconciliation);
